import React from 'react';
import {
  Datagrid,
  EmailField,
  List,
  ReferenceField,
  TextField,
  useTranslate,
} from 'react-admin';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const ClientList = (props) => {
  const translate = useTranslate();
  useDocumentTitle(
    translate('app.page_title.list', {
      resource: translate('resources.client.name', { smart_count: 2 }),
    }),
  );
  return (
    <List {...props} bulkActionButtons={false} perPage={25}>
      <Datagrid rowClick="edit">
        <TextField source="fullname" />
        <ReferenceField source="account_id" reference="account">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="function" />
        <EmailField source="email" />
        <TextField source="phone" />
        <TextField source="mobile_phone" />
      </Datagrid>
    </List>
  );
};

export default ClientList;
